import styles from './ProgressBar.module.scss';

interface IProgressBarProps {
  progress: number;
  total: number;
}

const ProgressBar = ({ progress, total }: IProgressBarProps) => {
  const progressPercentage = (progress / total) * 100;

  return (
    <div className={styles.container}>
      <div className={styles.progress} style={{ width: `${progressPercentage.toString()}%` }}></div>
    </div>
  );
};

export default ProgressBar;
